export * from "@diana-ui/registry";